module.exports = __webpack_public_path__ + "static/marketers-36f86ae785841906697df0abbdf96049.png";